import autobind from 'autobind-decorator';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Icon, Input, Alert, Spin, Row, Col, Card, Checkbox, Button, Modal, Badge, Tooltip } from 'antd';
import { connect } from 'redux-scaffolding-ts';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { ProjectsStore, ProjectSummary, ProjectItem } from 'src/stores/projects-store';
import { Query, ItemState } from 'src/core/stores/dataStore';
import { TableModel, TableView } from 'src/core/ui/collections/table';
import { formatMessage } from 'src/core/services/http.service';
import { CommandResult } from '../../../core/stores/types';
import NewProjectView from './project-new';
import UpdateProjectView from './project-update';
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import Tour from 'reactour';
import steps from 'src/components/virtual-tour/virtual-tour-configs';
import { notify } from 'src/core/ui/floatingNotification';
import { CacheProps, withCache } from '../../../core/services/cache.service';
import { IdentityProps, withIdentity } from '../../../core/services/authentication';
import { navigate } from '../../../core/ui/link';
import { UserProfileProps, withUserProfile } from "../../../components/user-profile";
import {isReadOnly} from "../../../utils/CheckValidationbyUsers";
import { BulkInsertUpload } from '../../../components/bulk-upload/bulkInsert-upload'
import { formatDate } from 'src/core/utils/object'
import { successNotification } from '../../../components/systemNotifications/notificationService';


// tslint:disable-next-line:no-empty-interface
interface ProjectsViewProps extends RouteComponentProps<{ companyId: string }>, WithTranslation, CacheProps, UserProfileProps {
    companyName: string
    refresh: boolean,
    onRefresh: () => void;
    companyAllowCir: boolean;
    companyAllowCii: boolean;
}

interface ProjectsViewState {
    query: Query
    newProjectShown: boolean
    isTourOpen: boolean
    isConfirmApproveOpen: boolean,
    isEditModalProjectOpen: boolean,
    dataProject: any,
    isBusy?: boolean,
    selectedItems: any[]
}

@connect(['projects', ProjectsStore])
class ProjectsDashboard extends React.Component<ProjectsViewProps, ProjectsViewState> {

    private get projectsStore() {
        return (this.props as any).projects as ProjectsStore
    }

    constructor(props: ProjectsViewProps) {
        super(props)
        var queryStored = props.cache.getWithCustomKey("Projects", true)

        var query = { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: false }], skip: 0, take: 10 }

        if (queryStored)
            query = queryStored
        this.state = {
            query: query as any,
            newProjectShown: false,
            isTourOpen: false,
            isConfirmApproveOpen: false,
            isEditModalProjectOpen: false,
            dataProject: null,
            isBusy: false,
            selectedItems: []
        }
        this.projectsStore.changeUrl(props.match.params.companyId)
    }

    componentWillMount() {
        this.load(this.state.query)
    }

    componentDidUpdate() {
        if (this.props.refresh) {
            this.props.onRefresh()
            this.load(this.state.query)
        }
    }

    @autobind
    private load(query: Query) {
        this.props.cache.saveWithCustomKey("Projects", query);
        this.projectsStore.getAllAsync(query, undefined, this.props.match.params.companyId);
    }

    @autobind
    private onQueryChanged(query: Query) {
        this.setState({ query }, () => this.load(query));
    }

    @autobind
    private onDeleteRow(item: ProjectSummary, state: ItemState): Promise<CommandResult<any>> {
        this.setState({ selectedItems: [] });
        return new Promise((resolve, reject) => {
            this.projectsStore.deleteAsync(`${item.id}`).then(result => {
                resolve(result)
            }).catch(error => {
                error.message = `${item.title} : ${error.message}`
                reject(error)
            });
        })
    }

    @autobind
    private onNewItem() {
        this.setState({ newProjectShown: true });
    }

    @autobind
    private onNewItemClosed(id: string | undefined) {
        this.setState({ newProjectShown: false });
        this.load(this.state.query);
    }

    @autobind
    private setIsTourOpen(state: boolean) {
        this.setState({ isTourOpen: state });
    }

    @autobind
    private async setFieldValue(id: string, field: string, value: any) {
        const { t } = this.props
        await this.projectsStore.setEligibility(id, field, value)
            .catch(() => {
                notify({
                    type: "error",
                    autoClose: true,
                    description: t("There was an error saving changes"),
                    key: "error",
                    message: t("Error"),
                })
            })
    }


    private onReject = () =>
        new Promise(async (resolve, reject) => {
            this.setState({ isBusy: true });
            let projectId = this.state.dataProject.id;
            var companyId = this.props.match.params.companyId;
            this.projectsStore.changeUrl(companyId);
            await this.projectsStore.delete(projectId);
            this.setState({ isConfirmApproveOpen: false, isBusy: false });
            this.load(this.state.query);
        })
    private onSelectChange = (selectedRowKeys: any[]) => {
        this.setState({ selectedItems: selectedRowKeys });
    }
    private downloadExcelEmployees = async () => {
        const { query, selectedItems } = this.state;
        await this.projectsStore.exportProjects(query, selectedItems);
        successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'));
    }

    public render() {
        const { t } = this.props as any
        var tableModel = {
            query: this.state.query,
            columns: [
                {
                    sortable: true,
                    field: 'title',
                    title: t('Project Name'),
                    renderer: (data) => {
                        if (data.approved == false) {
                            return (<><Icon type="project" />&nbsp;<span>{data.title}</span></>)
                        }
                        return (<span>
                            <Link data-tut="reactour__navegateProject2" to={{
                                pathname: `/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${data.id}`,
                                state: {
                                    titles: [...(this.props.location.state ? (this.props.location.state as any).titles || [] : []),
                                        { url: `/time-tracking/admin/companies/${this.props.match.params.companyId}`, title: this.props.companyName },
                                        { url: `/time-tracking/admin/companies/${this.props.match.params.companyId}/projects`, title: t('Projects') },
                                    ],
                                }
                            }}><Icon type="project" />&nbsp;<span>{data.title}</span></Link>
                        </span>)
                    },
                    editor: (data) => <Input />
                },
                {
                    field: 'code',
                    title: t('Code'),
                    align: 'center',
                    renderer: (data) => <span> {data.code} </span>
                },
                {
                    field: 'reference',
                    title: <EditableTooltip name='project-reference'> {t('Reference')} </EditableTooltip>,
                    renderer: (data) => <span>{data.reference}</span>,
                    editor: (data) => <Input />
                },
                {
                    field: 'Managers',
                    title: t('Project managers'),
                    align: 'center',
                    renderer: (data) => <span> {data.managers.join(', ')} </span>
                },
                {
                    sortable: true,
                    field: 'isPrivate',
                    title: <EditableTooltip name='project-visibility'> {t('Visibility')} </EditableTooltip>,
                    renderer: (data) => <span>{data.isPrivate ? t("Private") : t("Public")}</span>,
                    editor: (data) => <Checkbox />
                },
                {
                    sortable: true,
                    field: 'createdOn',
                    align: 'center',
                    title: t('Creation Date'),
                    renderer: (data) => <span>{formatDate(data.createdOn)}</span>,
                },
                {
                    sortable: true,
                    field: 'createdBy',
                    align: 'center',
                    title: t('Created By'),
                    renderer: (data) => <span>{data.createdBy}</span>,
                },
                {
                    field: 'approved',
                    title: t('State'),
                    align: 'center',
                    renderer: (data) => {
                        if ((data.approved == undefined || data.approved) == true) {
                            return (<span>{t('Approved')}</span>)
                        } else if (this.props.userProfile.roles?.includes("CompanyDataViewer") && this.props.userProfile.roles?.length == 1) {
                            return (<span>{t('Pending')}</span>)
                        } else {
                            return (
                                <Tooltip placement="top" title={t('Pending approval')}>
                                    <Button
                                        style={{ backgroundColor: '#00aeff', color: 'white' }}
                                        key="back"
                                        onClick={() => this.setState({ isConfirmApproveOpen: true, dataProject: data })}>{this.props.t('Pending')}
                                    </Button>
                                </Tooltip>
                            )
                        }
                    },
                }

            ],
            data: this.projectsStore.state,
            sortFields: [{
                field: 'title',
                text: t('Project Name'),
                useProfile: false
            },
                {
                    field: 'isPrivate',
                    text: t('Visibility'),
                    useProfile: false
                }],
        } as TableModel<ProjectSummary>;

        const hasSelected = tableModel.data.items.some((x) => this.state.selectedItems.some(t => t == (x.item as any)['id']));

        if (this.props.companyAllowCir) {
            tableModel.columns.push({
                field: 'rdTaxRelief',
                title: t('R&D Tax relief?'),
                align: 'center',
                renderer: (data) => <Checkbox disabled={!data.allowedCir || data.approved == false} checked={data.rdTaxRelief} onChange={(evt) => { if (!isReadOnly(this.props.userProfile)) this.setFieldValue(data.id, 'rdTaxRelief', evt.target.checked) }} />,
                editor: (data) => <Checkbox disabled={!data.allowedCir} />
            })
        }

        if (this.props.companyAllowCii) {
            tableModel.columns.push(
                {
                    field: 'tiTaxRelief',
                    title: t('TI Tax relief?'),
                    align: 'center',
                    renderer: (data) => <Checkbox disabled={!data.allowedCii || data.approved == false} checked={data.tiTaxRelief} onChange={(evt) => { if (!isReadOnly(this.props.userProfile)) this.setFieldValue(data.id, 'tiTaxRelief', evt.target.checked) }} />,
                    editor: (data) => <Checkbox disabled={!data.allowedCii} />
                })
        }

        
        return <Spin size='large' spinning={this.projectsStore.state.isBusy}>
            <Row gutter={0} >
                <Col span={2}>
                    <div data-tut="reactour__navegateProject1" style={{ padding: 0, margin: 0, width: '100%', height: '40px', zIndex: -1, position: 'relative', bottom: '-35px' }}></div>
                </Col>
                <Col span={10}>
                    <Tour
                        steps={(isReadOnly(this.props.userProfile)) ? steps(t).stepsProjectsReadOnly : steps(t).stepsProjects}
                        isOpen={this.state.isTourOpen}
                        onRequestClose={() => this.setIsTourOpen(false)}
                    />
                </Col>
                <Col span={12}>
                    <Button data-tut="reactour__projectsInit" type={"link"} style={{ float: 'right', marginBottom: 5 }} onClick={() => this.setIsTourOpen(true)} icon={'caret-right-fill'}>  {t("Discover Projects")} </Button>
                </Col>
            </Row>
            <div data-tut="reactour__navegateProject" style={{ padding: 0, margin: 0 }}>
                <TableView
                    showDeleteStatusWindow
                    onSelectedChange={this.onSelectChange}
                    rowKey='id'
                    model={tableModel}
                    scroll={{ x: 1800 }}
                    error={this.projectsStore.state.result && !this.projectsStore.state.result.isSuccess && formatMessage(this.projectsStore.state.result)}
                    embedded={false}
                    onQueryChanged={(q: Query) => this.onQueryChanged(q)}
                    onRefresh={() => this.load(this.state.query)}
                    canEdit={false}
                    canDelete={!isReadOnly(this.props.userProfile)}
                    onDeleteRow={this.onDeleteRow}
                    canCreateNew={!isReadOnly(this.props.userProfile)}
                    onNewItem={this.onNewItem}
                    showDetailedDeleteReport
                    leftToolbar={
                        [
                            <li>
                                <BulkInsertUpload
                                   bulkTemplateName={t('projects.xlsx')}
                                   bulkInsertUrl={isReadOnly(this.props.userProfile) ? undefined : `api/v1/companies/${this.props.match.params.companyId}/projects/bulk_insert`}
                                   bulkTemplateUrl={`api/v1/companies/${this.props.match.params.companyId}/projects/template`}
                                   tooltipTitle={t('Bulk upload items') }
                                />
                            </li>,
                            <li>
                                <BulkInsertUpload
                                   bulkTemplateName={t('MemberAssignment.xlsx')}
                                   bulkInsertUrl={`api/v1/companies/${this.props.match.params.companyId}/projects/bulk_members_assignment`}
                                   bulkTemplateUrl={`api/v1/companies/${this.props.match.params.companyId}/projects/members_assignment_template`}
                                   tooltipTitle={t('Bulk Members Assignment') }
                                />
                            </li>,
                            <li>
                                <EditableTooltip name="member-assignment" noIcon >
                                    <Button
                                        disabled={this.projectsStore.state.count == 0}
                                        icon='usergroup-add'
                                        onClick={() => {
                                            navigate(this.props.history, {
                                                pathname: `/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/projects-assignments/`,
                                                state: {
                                                    titles: [{ title: this.props.companyName, url: `/time-tracking/admin/companies/${this.props.match.params.companyId}` }, { title: "Projects", url: `/time-tracking/admin/companies/${this.props.match.params.companyId}/projects` }],
                                                }
                                            });
                                        }}
                                    >
                                        {t("Member Assignment")}
                                    <Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} />
                                    </Button>
                                    <Button
                                        style={{ marginLeft: '5px' }}
                                        disabled={this.projectsStore.state.count == 0}
                                        icon='book'
                                        onClick={() => {
                                            navigate(this.props.history, {
                                                pathname: `/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/templates-assignments/`,
                                                state: {
                                                    titles: [{ title: this.props.companyName, url: `/time-tracking/admin/companies/${this.props.match.params.companyId}` }, { title: "Projects", url: `/time-tracking/admin/companies/${this.props.match.params.companyId}/projects` }],
                                                }
                                            });
                                        }}
                                    >
                                        {t("Template Assignment")}
                                    <Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} />
                                    </Button>
                                </EditableTooltip>
                            </li>,
                            <li>
                                <BulkInsertUpload
                                    bulkTemplateName={t('TasksAssignment.xlsx')}
                                    bulkInsertUrl={`api/v1/companies/${this.props.match.params.companyId}/projects/bulk_tasks_assignment`}
                                    bulkTemplateUrl={`api/v1/companies/${this.props.match.params.companyId}/projects/tasks_assignment_template`}
                                    tooltipTitle={t('Bulk Tasks Upload')}
                                />
                            </li>,
                            <li>
                                <Tooltip placement="topLeft" title={t(`${hasSelected && this.state.selectedItems.length > 0 ? 'Download selected' : 'Download All'}`)}>
                                    <Button onClick={() => this.downloadExcelEmployees()}
                                        style={{ backgroundColor: 'rgb(0, 174, 255)', color: 'white' }}
                                        disabled={this.projectsStore.state.items.length == 0}
                                    >
                                        <Icon type='download' />
                                    </Button>
                                </Tooltip>
                            </li>].map(item => item)
                            
                    }
                >
                </TableView>
                {this.state.newProjectShown &&
                    <NewProjectView
                        companyId={this.props.match.params.companyId}
                        onClose={this.onNewItemClosed}
                        firstTaskOptional={true}
                        companyAllowCir={this.props.companyAllowCir}
                        companyAllowCii={this.props.companyAllowCii}
                    />}
            </div>

            <Modal
                footer={[
                    <Button type="danger" onClick={this.onReject}>{t("Reject")}</Button>,
                    <Button type="primary" onClick={() => this.setState({ isEditModalProjectOpen: true, isConfirmApproveOpen: false })}>{t("Ok")}</Button>
                ]}
                maskClosable={true}
                visible={this.state.isConfirmApproveOpen}
                closable={true}
                onCancel={() => this.setState({ isConfirmApproveOpen: false })}
                title={t('Confirmation required')}>
                <div>
                    <p>
                        {t("Do you wish to approve the project?")}
                    </p>
                </div>
                <Spin spinning={this.state.isBusy}></Spin>
            </Modal>

            {this.state.isEditModalProjectOpen && <UpdateProjectView
                companyAllowCir={this.props.companyAllowCir}
                companyAllowCii={this.props.companyAllowCii}
                firstTaskOptional={false}
                companyId={this.props.match.params.companyId}
                dataProject={this.state.dataProject}
                onClose={() => this.setState({ isEditModalProjectOpen: false })}
                onRefresh={() => this.load(this.state.query)}
                onOk={(pid) => {
                }}
            />}

        </Spin>
    }
}

// Wire up the React component to the Redux store
export default withUserProfile(withCache(withTranslation()(withIdentity(withRouter(ProjectsDashboard)))));



